import type { UpdateUserDto } from './user.schema';
import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAppSelector } from '@/redux/hooks';
import { QueriesKeys } from '../queriesKeys';
import { userApi } from './user.api';

export const userMeQueryOptions
  = queryOptions({
    queryKey: [QueriesKeys.user],
    queryFn: () => userApi.getUserMe(),
  });

export const useUserMeQuery = () => {
  const { userSession } = useAppSelector(state => state.user);

  return useQuery({
    ...userMeQueryOptions,
    enabled: userSession,
  });
};

/** Shared so every invalidation site stays in step with the query itself. */
export const paymentMethodsQueryKey = [QueriesKeys.user, QueriesKeys.paymentMethods];

export const usePaymentMethodsQuery = () => {
  const { userSession } = useAppSelector(state => state.user);
  return useQuery({
    queryKey: paymentMethodsQueryKey,
    queryFn: () => userApi.getUserPaymentMethods(),
    enabled: userSession,
  });
};

export const useUpdateUserMeMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: UpdateUserDto) => userApi.patchUserMe(data),
    onSuccess: (user) => {
      queryClient.setQueryData([QueriesKeys.user], user);
    },
  });
};

export const useVerifyPaymentMethodMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, cardId }: { userId: string; cardId: string }) => {
      return userApi.verifyPaymentMethod(userId, cardId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: paymentMethodsQueryKey });
    },
  });
};
